module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABXklEQVR4AezVwQnCQBCG0ZSQEqzAGnKwkJSSjlJCSkgFkhIsQVfMgIIMAQ95uBn4YM7/5TXKXc+XU+m29vwboXiE5tJ9bT4G+myIcd4ajoFedV/GibraB2pLSzLQUmprHmhMxonGWgfqN4wT9bUNFKRvGmhP+gXS0/amHyA9CaAfID0JoB8gPQmgnyI9kujnSNfo50jX6KdIF+lnSFfpJ0iX6SdIl+kHSLfpt0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+i3SQfot0kH6LdJB+hXSAfo/32g6Y8Gmh7t3IEJAFEIw9D9t3YKMeBbofDPs7Y5EIhAnpiPtDG/M+b9KFo1LKtBu4PdwTBjuTLtnX0CAjkcOj0LL4i/pAQSoBLBE+IUAxYkzwmkiqDMog6lUKeSqdT7rxauFg4sAE0BbgKPA7AE0QXyRqAkJnAA/73xGudv8tQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2666.png
// module id = 1365
// module chunks = 0